import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    line-height: 180%;
    margin-bottom: 32px;
    text-align: center;
    color: ${theme.colors.gray.dark};
  `}
`

export const Warning = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    text-align: center;
    margin-bottom: 32px;
    margin-top: -16px;
    color: ${theme.colors.error.color};
  `}
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const InputsBox = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 14px;
`

export const AddAccountButton = styled(Box)`
  ${({ theme }) => css`
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    color: ${theme.colors.secondary};
    cursor: pointer;

    svg {
      width: 24px;
      height: 24px;
      color: ${theme.colors.secondary};
    }
  `}
`

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 16px;
    margin-bottom: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      gap: 16px;
    }
  `}
`
